module.exports = __webpack_public_path__ + "static/plane-d83c8b62baba9f3c0d2cdbb00a80a8ab.png";